import React, {useState } from 'react'
import { useTranslate, useNotify, useRedirect, } from 'react-admin'
import { CircularProgress, ButtonGroup, Button, TextField, Grid, Typography, Icon, FormHelperText, Container, InputLabel, FormControl, MenuItem, Select, Skeleton } from '@mui/material'
import { billingFormServices } from 'src/services/payment/billingForm/billingForm.service';
import BillingFormConciliationCreate from './billingFormConciliationCreate';
import BillingFormExtractsDownload from './billingFormExtracsDownload';

import { hasPermissionFunction } from 'src/helper/HasPermission';
import { ConciliationList } from './ConciliationList';

function BillingFormConciliations() {
	const notify = useNotify()
	const translate = useTranslate()

	// Navigation Button
	const [selectedView, setSelectedView] = useState("conciliation");

	const handleViewChange = (view) => {
		setSelectedView(view); // Cambiar el estado según el botón seleccionado
	};

	return (
		<Container className='pageGeneralContainer pageConciliationViewContainer'>
			{(hasPermissionFunction('bilingform_conciliation', 'show') && hasPermissionFunction('bilingform_conciliation', 'edit')) ?
				<Grid container spacing={3} className='pageCard'>
					<Grid item sm={12}>
						<div className='headerButtons'>
							<ButtonGroup variant="outlined" aria-label="Basic button group">
								<Button
									onClick={() => handleViewChange("conciliation")}
									variant={selectedView === "conciliation" ? "contained" : "outlined"} // Estilo dinámico
								>
									{translate('ra.action.uploadAndReconcileStatement')}
								</Button>
								<Button
									onClick={() => handleViewChange("extracts")}
									variant={selectedView === "extracts" ? "contained" : "outlined"} // Estilo dinámico
								>
									{translate('ra.action.generateAndDownloadStatement')}
								</Button>
							</ButtonGroup>
						</div>
					</Grid>
					<Grid item sm={12}>
						{selectedView === 'conciliation' ?
							<BillingFormConciliationCreate />
							:
							<BillingFormExtractsDownload />
						}
					</Grid>
					<Grid item sm={12}>
						<br /><br /><br /><br /><br /><br /><br /><br />
					</Grid>
				</Grid>
				:
				<Grid container spacing={3} className='pageCard'>
					<Grid item sm={12} style={{ textAlign: 'center' }}>
						<Typography variant="body2" color="textSecondary" component="span">
							({translate('ra.message.permissions_required')})
						</Typography>
					</Grid>
				</Grid>
			}
			<ConciliationList/>
		</Container>
	)
}
export default BillingFormConciliations